export default {
  DEFAULT: "/search",
  MENU: [
    {
      name: "เมนู",
      menus: [
        { icon: "user", path: "/search", title: "ค้นหาสมาชิก" },
        { icon: "user-add", path: "/register", title: "สมัครสมาชิกใหม่" },
      ],
    },
    {
      role: ["superuser"],
      name: "จัดการข้อมูล",
      menus: [
        {
          icon: "idcard",
          path: "/management/admin",
          title: "จัดการผู้ใช้ระบบ",
        },
      ],
    },
    {
      name: "อื่น ๆ",
      role: ["superuser"],
      menus: [
        {
          icon: "qrcode",
          path: "/management/register",
          title: "ลงทะเบียนพนักงาน",
        },
      ],
    },
    {
      name: "รายงาน",
      menus: [
        {
          icon: "printer",
          path: "/settlement-report",
          title: "ใบสรุปแลกคะแนนรายวัน",
        },
        {
          icon: "printer",
          path: "/transaction-report",
          title: "สรุปการใช้สิทธิพิเศษตามช่วงเวลา",
        },
      ],
    },
    {
      name: "ปรับแต่ง",
      menus: [{ icon: "setting", path: "/settings", title: "ตั้งค่า" }],
    },
  ],
}



// WEBPACK FOOTER //
// ./src/constants/menu.js